// removed by extract-text-webpack-plugin
module.exports = {"IP7Index":"IP7Index__IP7Index__zx1iQ","title":"IP7Index__title__vn6nM","IP7Allocations":"IP7Index__IP7Allocations__2TB9r","IP7Assets":"IP7Index__IP7Assets__eqf25","totalWrong":"IP7Index__totalWrong__2lWkg"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/IP7Index/IP7Index.css
// module id = 502
// module chunks = 0